import Flickity from 'flickity';

export default () => ({
    carousel: null,
    carouselRefreshInterval: null,
    carouselTimeout: window.config.CAROUSELS.PROJECTS_CASE_STUDY_META_CAROUSEL,

    init() {
        this.carousel = new Flickity(document.querySelector('.projects-case-study-carousel-instance'), {
            prevNextButtons: false,
            pageDots: false,
            cellAlign: 'left',
            contain: true,
            autoPlay: this.carouselTimeout,
            pauseAutoPlayOnHover: false,
            imagesLoaded: false,
            draggable: false
        });

        this.buttons = this.$el.querySelectorAll('.button');

        if (this.buttons.length > 0) {
            this.handleCarouselTimerButton();

            this.carousel.on('select', () => {
                this.carousel.stopPlayer();

                this.buttons.forEach((button, index) => {
                    if (index === this.carousel.selectedIndex) {
                        button.classList.add('active');
                        button.querySelector('.diamond-active-border').style.strokeDashoffset = '300px';
                    } else {
                        button.classList.remove('active');
                    }
                });

                this.carousel.playPlayer();
                this.handleCarouselTimerButton();
            });
        }
    },

    handleClick(index) {
        this.carousel.select(index);
        this.carousel.reposition();
    },

    handleCarouselTimerButton() {
        if (this.carouselRefreshInterval !== null) {
            clearInterval(this.carouselRefreshInterval);
        }

        let offset = 300;
        const intervalDuration = this.carouselTimeout / offset;

        this.carouselRefreshInterval = setInterval(() => {
            offset--;

            const currentButton = this.buttons[this.carousel.selectedIndex];
            if (!currentButton) return;

            const diamondWhiteBorder
                = currentButton.querySelector('.diamond-active-border');
            if (diamondWhiteBorder) {
                diamondWhiteBorder.style.strokeDashoffset = `${offset}px`;
            }

            if (offset <= 0) {
                clearInterval(this.carouselRefreshInterval);
                this.carouselRefreshInterval = null;
                this.carousel.next(true);
            }
        }, intervalDuration);
    },
});